/**
 * @description Base controller for two separate portal controllers
 * @example
 * // Inside child controller
 * var baseCtrl = $controller('BaseVulnRequestCtrl', {$scope: $scope});
 */
;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .controller('BaseVulnRequestCtrl', BaseVulnRequestCtrl)

  function BaseVulnRequestCtrl($scope, $routeParams) {
    'ngInject'

    var _traceUuid

    this.$onInit = function () {
      angular.extend($scope, {
        getTraceUuid: getTraceUuid
      })

      init()
    }

    function init() {
      _traceUuid = $routeParams.uuid
    }

    function getTraceUuid() {
      return _traceUuid
    }
  }
})()
